export const API_ENDPOINTS = {
  AUTH: {
    LOGIN: "/",
    REGISTER: "/register",
  },
  USER: {
    GET_ALL: "/users",
    GET_BY_ID: (id) => `/users/${id}`,
  },
  CATALOG: {
    GET_LIST: "/Catalog",
  },
  CART: {
    ADD: "/CartAdd",
    DETAIL: "/CARTDETAIL",
    SUMMARY: "/CARTSUMMARY",
    EDIT: "/CartEdit",
    DELETE: "/CartDelete",
    CHECKOUT: "/Checkout",
  },
  QUOTATION: {
    SUMMARY: "/QUOTSUMMARY",
    DETAIL: "/QUOTDETAIL",
  },
  ORDER: {
    SUMMARY: "/ORDERSUMMARY",
    DETAIL: "/ORDERDETAIL",
  },
};